(function () {
    'use strict';
    var m = angular.module('profiles');
    m.controller('ProfileController', ["$scope", "$routeParams", "widgetPolling", "sizeClasses", "path", "objectTypeDao", "modulesDao", "$q", "defaultHttpErrorHandler", "openAppStatusListener", "$injector", "$route", function ($scope, $routeParams, widgetPolling, sizeClasses, path, objectTypeDao, modulesDao, $q, defaultHttpErrorHandler, openAppStatusListener, $injector, $route) {
        var widgetsScope = {
            entityType: $routeParams.entityType,
            id: $routeParams.id
        };
        var widgetsPath = 'entity/' + widgetsScope.entityType;
        var commonQueries = [objectTypeDao.retrieve().then(function (response) {
                widgetsScope.objectTypes = response;
            })];
        var customJsonExists = false;
        var customJson = null;
        commonQueries.push(path('profiles').ctrl('profile').json('entity/' + widgetsScope.entityType).retrieve(true).onRequestFail(function () {
            return $q.when({});
        }).then(function (response) {
            if (response.data) {
                customJsonExists = true;
                customJson = response.data;
            }
        }));
        $q.all(commonQueries).then(function (responses) {
            var saasByEntityType = widgetsScope.objectTypes.data && widgetsScope.objectTypes.data.entities && widgetsScope.objectTypes.data.entities[widgetsScope.entityType] && widgetsScope.objectTypes.data.entities[widgetsScope.entityType].saas;
            if (saasByEntityType) {
                widgetsScope.module = saasByEntityType;
                $injector.get('modulesManager').currentModule(widgetsScope.module === 'office365_mgmnt' ? 'office365_emails' : widgetsScope.module);    //TODO: this line is for compatibility of v2 with v1
            }
            if (!customJsonExists && !saasByEntityType) {
                return $q.reject({ status: 404 });
            }
            if (!customJson || !customJson.title) {
                $route.current.fullTitle = '#' + JSON.stringify({
                    display: 'html',
                    text: '<strong>' + _(widgetsScope.entityType.split('_')).last() + ' profile</strong>'
                });
            }
            return modulesDao.entityInfoRaw(widgetsScope.module, widgetsScope.entityType).then(function (rawEntityInfo) {
                widgetsScope.rawEntityInfo = rawEntityInfo;
                if (customJsonExists) {
                    return;
                }
                if (rawEntityInfo.sec_type_connected && rawEntityInfo.sec_type_connected.length) {
                    widgetsPath = 'basic-scannable-profile';
                } else {
                    widgetsPath = 'basic-profile';
                }
            });
        }).then(function () {
            widgetPolling.scope(widgetsScope);
            widgetPolling.updateWidgets(path('profiles').ctrl('profile').json(widgetsPath).path, path('profiles').ctrl('profile').json('common-widgets').path);
            $scope.widgetPolling = widgetPolling;
            $scope.getSizeClasses = sizeClasses;
        }, defaultHttpErrorHandler);
        var destroyAppStatusListener = openAppStatusListener($scope);
        $scope.$on('$destroy', function () {
            destroyAppStatusListener();
        });
    }]);
}());